export default __webpack_public_path__ + "static/media/haylo-gold.fe600bf6.png";